var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(
      [_vm.iconsRowOne, _vm.iconsRowTwo, _vm.iconsRowThree],
      function (iconRow, rowIndex) {
        return _c(
          "div",
          {
            key: rowIndex,
            class: [
              "size-xl display-flex flex-content-around",
              {
                "margin-y-4xs": rowIndex === 0 || rowIndex === 2,
                "margin-y-sm": rowIndex === 1,
              },
            ],
          },
          _vm._l(iconRow, function (icon, iconIndex) {
            return _c(
              "span",
              { key: iconIndex },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.getIconString(_vm.fullStyleName, icon) },
                }),
              ],
              1
            )
          }),
          0
        )
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }